import TextRangeCore from '../../Core/Components/_filterComponents/TextRangeFilter'
import TextCore from '../../Core/Components/_filterComponents/TextFilter'
import InsuranceCompanyFilterCore from '../../Core/Components/_filterComponents/InsuranceCompanyFilter'
import IconValueFilterCore from '../../Core/Components/_filterComponents/IconValueFilter'
import QuoteTextFilter from '../../Core/Components/_filterComponents/QuoteTextFilter'
import RadioTextFilter from '../../Core/Components/_filterComponents/RadioTextFilter'

export const TextRange = TextRangeCore
export const Text = TextCore
export const InsuranceCompanyFilter = InsuranceCompanyFilterCore

export default {
  textRange: TextRange,
  text: Text,
  insuranceCompanyFilter: InsuranceCompanyFilter,
  iconValueFilter: IconValueFilterCore,
  quoteTextFilter: QuoteTextFilter,
  radioTextFilter: RadioTextFilter,
}
